import { AutocompleteWithLabel } from '@adotel/components'
import {
  LazyQueryExecFunction,
  OperationVariables,
  useQuery
} from '@apollo/client'
import { Button } from '@material-ui/core'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { ACCOMMODATIONS_QUERY } from '../../graphql/accommodation'
import { getTranslate } from '../../localization'
import { Accommodation } from '../../types/accommodation'
import {
  ChannelPushFiltersInput,
  PushDetails,
  HealthStatus
} from '../../types/channelPush'
import useStyles from './styles/channelPushFilters.styles'

interface ChannelPushFiltersProps {
  filters: ChannelPushFiltersInput
  setfilters: React.Dispatch<React.SetStateAction<ChannelPushFiltersInput>>
  getChannelPush: LazyQueryExecFunction<
    {
      channelPush: PushDetails
    },
    OperationVariables
  >
}

function ChannelPushFilters({
  filters,
  setfilters,
  getChannelPush
}: ChannelPushFiltersProps) {
  const classes = useStyles()
  const [autoCompleteLabelsFroAccommodation, setAutoCompleteForAccommodations] =
    useState<any[]>([])
  const [autoCompleteLabelsFroStatus, setAutoCompleteLabelsFroStatus] =
    useState<any>(null)

  const statusMenuItem: {
    value: HealthStatus
    label: string
  }[] = [
    { value: 'Normal', label: 'Normal' },
    { value: 'Warning', label: 'Warning' },
    { value: 'Critical', label: 'Critical' }
  ]
  const { channelCode } = useParams<{ channelCode: string }>()

  const { data: accommodationsData, loading: loadingForAccommodation } =
    useQuery<{ accommodations: Accommodation[] }>(ACCOMMODATIONS_QUERY, {
      notifyOnNetworkStatusChange: true,
      variables: { channelCode: channelCode }
    })

  const onClickApply = () => {
    getChannelPush({ variables: { filters: filters } })
  }

  const resetFilters = () => {
    setAutoCompleteForAccommodations([])
    setAutoCompleteLabelsFroStatus(null)
    setfilters({
      ...filters,
      propertyCodes: [],
      status: undefined
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.eachRow}>
        <AutocompleteWithLabel
          value={autoCompleteLabelsFroAccommodation}
          showSelectAll
          multiple
          limitTags={2}
          fullWidth
          getOptionLabel={(option) => option.label || ''}
          label={getTranslate('Accommodation')}
          inputSize="small"
          size="small"
          options={
            accommodationsData
              ? accommodationsData?.accommodations.map((item) => ({
                  label: item.basicDetails.name,
                  value: item.basicDetails.propertyCode || '',
                  code: item.basicDetails?.propertyCode || '',
                  id: item.basicDetails.accommodationID || ''
                }))
              : []
          }
          onChange={(_, v: any) => {
            if (v.length > 0) {
              const tempSelectedAccs = v.map((item: any) => ({
                label: item.label,
                value: item.value,
                code: item.code,
                id: item.id
              }))
              setAutoCompleteForAccommodations(tempSelectedAccs)
              setfilters(() => {
                const temp = tempSelectedAccs.map((ele: any) => ele.value)

                return {
                  ...filters,
                  propertyCodes: temp
                }
              })
            } else {
              setAutoCompleteForAccommodations([])
              setfilters({
                ...filters,
                propertyCodes: []
              })
            }
          }}
          loading={loadingForAccommodation}
          loadingText={getTranslate('Loading') + '...'}
        />
        <AutocompleteWithLabel
          label={getTranslate('Status')}
          inputSize="small"
          placeholder={getTranslate('Select Status')}
          value={autoCompleteLabelsFroStatus}
          onChange={(_, v: any) => {
            if (v) {
              setAutoCompleteLabelsFroStatus({
                value: v.value,
                label: v.label
              })
              setfilters({
                ...filters,
                status: v.value
              })
            } else {
              setAutoCompleteLabelsFroStatus(null)
              setfilters({
                ...filters,
                status: undefined
              })
            }
          }}
          options={statusMenuItem.map((item) => ({
            value: item.value,
            label: getTranslate(item.label)
          }))}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
        />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          variant="text"
          className={classes.resetButton}
          onClick={resetFilters}>
          {getTranslate('Reset')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickApply}
          disabled={false}>
          {getTranslate('Apply')}
        </Button>
      </div>
    </div>
  )
}

export default ChannelPushFilters
